import { useState, useEffect } from 'react';
import { userStateService, UserState } from '../services/UserStateService';

export function useUserState(): UserState {
  const service = userStateService;
  const [userState, setUserState] = useState(service.getState());

  useEffect(() => {
    return service.subscribe((newState) => {
      setUserState(newState);
    });
  }, []);

  return userState;
}